(function () {
  function initCarousel(root) {
    if (!root || root.dataset.btsCarouselInit === "1") return;

    var track = root.querySelector(".btsImgTrack");
    var prev = root.querySelector(".btsImgPrev");
    var next = root.querySelector(".btsImgNext");
    var cards = Array.prototype.slice.call(root.querySelectorAll(".btsImgCard"));

    if (!track || !prev || !next || cards.length < 2) return;

    root.dataset.btsCarouselInit = "1";

    // --- Config ---
    var AUTOPLAY_MS = 3000;
    var CLONE_COUNT = 3; // enough for your "3 on screen" desktop view

    // --- Helpers ---
    function getGapPx() {
      try {
        var styles = window.getComputedStyle(track);
        var gap = styles.columnGap || styles.gap || "16px";
        return parseFloat(gap) || 16;
      } catch (e) {
        return 16;
      }
    }

    function getCardWidth() {
      var c = root.querySelector(".btsImgCard");
      return c ? c.getBoundingClientRect().width : 0;
    }

    function getStep() {
      var w = getCardWidth();
      if (!w) return 0;
      return w + getGapPx();
    }

    function setImmediateScroll(x) {
      // Jump without smooth animation (prevents visible "rewind")
      track.style.scrollBehavior = "auto";
      track.scrollLeft = x;
      // Restore smooth for user-initiated clicks
      requestAnimationFrame(function () {
        track.style.scrollBehavior = "smooth";
      });
    }

    // --- Build infinite loop by cloning ---
    // Clone last CLONE_COUNT to the front, and first CLONE_COUNT to the end
    var realCount = cards.length;
    var cloneN = Math.min(CLONE_COUNT, realCount);

    // mark originals
    cards.forEach(function (el) { el.dataset.btsReal = "1"; });

    // prepend clones (from end)
    for (var i = realCount - cloneN; i < realCount; i++) {
      var clone = cards[i].cloneNode(true);
      clone.dataset.btsClone = "1";
      track.insertBefore(clone, track.firstChild);
    }

    // append clones (from start)
    for (var j = 0; j < cloneN; j++) {
      var clone2 = cards[j].cloneNode(true);
      clone2.dataset.btsClone = "1";
      track.appendChild(clone2);
    }

    // After cloning, grab updated node list
    var allCards = Array.prototype.slice.call(track.querySelectorAll(".btsImgCard"));

    // --- Set starting position to the first "real" slide ---
    // Start after the prepended clones
    function snapToFirstReal() {
      var step = getStep();
      if (!step) return;
      setImmediateScroll(step * cloneN);
    }

    // Wait for layout/images
    setTimeout(snapToFirstReal, 50);
    window.addEventListener("resize", function () {
      // Keep the viewport aligned after resizing
      // Find nearest slide index and re-snap cleanly
      var step = getStep();
      if (!step) return;
      var idx = Math.round(track.scrollLeft / step);
      setImmediateScroll(idx * step);
    });

    // --- Loop correction on scroll ---
    // If user scrolls into the cloned region, jump to matching real region
    var isJumping = false;

    function correctLoopIfNeeded() {
      if (isJumping) return;

      var step = getStep();
      if (!step) return;

      var maxScroll = track.scrollWidth - track.clientWidth;

      // Regions:
      // [0 ... (cloneN-1)] => prepended clones
      // [(cloneN) ... (cloneN+realCount-1)] => real slides
      // [(cloneN+realCount) ... end] => appended clones
      var leftBoundary = step * (cloneN - 0.5);
      var rightBoundary = step * (cloneN + realCount - 0.5);

      if (track.scrollLeft < leftBoundary) {
        // jumped too far left into prepended clones => move to matching real at end
        isJumping = true;
        var newLeft = step * (cloneN + realCount - 1);
        setImmediateScroll(newLeft);
        setTimeout(function () { isJumping = false; }, 60);
      } else if (track.scrollLeft > rightBoundary) {
        // too far right into appended clones => move to matching real at start
        isJumping = true;
        var newLeft2 = step * cloneN;
        setImmediateScroll(newLeft2);
        setTimeout(function () { isJumping = false; }, 60);
      }
    }

    track.addEventListener("scroll", function () {
      // Throttle-ish using rAF
      requestAnimationFrame(correctLoopIfNeeded);
    });

    // --- Navigation: one slide at a time ---
    function goNext() {
      var step = getStep();
      if (!step) return;
      track.scrollTo({ left: track.scrollLeft + step, behavior: "smooth" });
    }

    function goPrev() {
      var step = getStep();
      if (!step) return;
      track.scrollTo({ left: track.scrollLeft - step, behavior: "smooth" });
    }

    prev.addEventListener("click", function () {
      stopAutoplay();
      goPrev();
      startAutoplay();
    });

    next.addEventListener("click", function () {
      stopAutoplay();
      goNext();
      startAutoplay();
    });

    // --- Autoplay (one slide every 3s), pause on interaction ---
    var timer = null;
    var paused = false;

    function startAutoplay() {
      if (timer || paused) return;
      timer = setInterval(function () {
        goNext();
      }, AUTOPLAY_MS);
    }

    function stopAutoplay() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    function pause() {
      paused = true;
      stopAutoplay();
    }

    function resume() {
      paused = false;
      startAutoplay();
    }

    // Pause on hover (desktop)
    track.addEventListener("mouseenter", pause);
    track.addEventListener("mouseleave", resume);

    // Pause on touch (mobile)
    track.addEventListener("touchstart", pause, { passive: true });
    track.addEventListener("touchend", function () {
      // small delay so it doesn’t fight momentum scroll
      setTimeout(resume, 400);
    }, { passive: true });

    // Pause when tab not visible
    document.addEventListener("visibilitychange", function () {
      if (document.hidden) pause();
      else resume();
    });

    // Kick off autoplay
    startAutoplay();
  }

  function initAll() {
    document.querySelectorAll(".bts-img-carousel").forEach(initCarousel);
  }

  document.addEventListener("DOMContentLoaded", initAll);
  setTimeout(initAll, 500);
  setTimeout(initAll, 1500);
})();
